import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './modulos/modulo-login/components/login/login.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'main',
    component: LayoutComponent,
    children: [
      {
        //path: 'aliada',
        path: 'bienvenido',
        loadChildren: () => import('./modulos/modulo-page-bienvenida/modulo-page-bienvenida.module').then(m => m.PageBienvenidaModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./modulos/modulo-dashboard/components/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'modulo-se',
        loadChildren: () => import('./modulos/modulo-seguridad/modulo-seguridad.module').then(m => m.SeguridadModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'modulo-maestros',
        loadChildren: () => import('./modulos/modulo-maestros/modulo-maestros.module').then(m => m.MaestroModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'modulo-presupuestos',
        loadChildren: () => import('./modulos/modulo-presupuestos/modulo-presupuestos.module').then(m => m.ModuloPresupuestosModule),
        canActivate: [AuthGuard]
      }
    ]
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
